import React from 'react'

export default class ProLabel extends React.Component {

  render(){
    const { style, className, beta } = this.props
    return (
      <div style={style || {}} className={`pro-label ${className}`}>
        {beta ? 'BETA' : 'PRO'}
      </div>
    )
  }

}